module.exports = __webpack_public_path__ + "img/1.a10ac4cb.jpg";